import { fetchOrderAttributes } from '@/entities/attributes/thunks/fetchOrderAttributes'
import { fetchColumnDefinitions } from '@/entities/columnDefinitions/thunks/fetchColumnDefinitions'
import { fetchDepotLites } from '@/entities/depots/thunks/fetchDepotLites'
import { fetchRunsheets } from '@/entities/schedules'
import { completeLoadingState } from '@/entities/userInterface/slices/loaderSlice'
import { setCurrentScreen } from '@/entities/userInterface/slices/userInterfaceSlice'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

// This asynchronous function is designed to initialize and set up global state in the Redux store related to the operations runsheet page.
export const setupRunsheet = createAsyncThunk<void, void, ThunkApiContext>('runsheet/setup', async (_, { dispatch }) => {
  await Promise.allSettled([
    dispatch(setCurrentScreen('runsheet')),
    dispatch(fetchDepotLites()),
    dispatch(fetchOrderAttributes()),
    dispatch(fetchColumnDefinitions({ gridTypeName: 'closeRs' })),
    dispatch(fetchColumnDefinitions({ gridTypeName: 'runsheetShift' })),
    dispatch(fetchColumnDefinitions({ gridTypeName: 'runsheetUnassigned' })),
    dispatch(fetchRunsheets({ runsheetIds: [] })),
  ])

  dispatch(completeLoadingState())
})